import { Injectable } from '@angular/core';
import { ObituaryApi } from './obituary.api';
import { iDeath } from './death.interface';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObituaryService {

  constructor(
		private api: ObituaryApi,
	) { }

	private getDeathFromData(data:any): iDeath {
		return { 
			id: +data["id"],
			name: data["name"],
			age: +data["age"],
			points: +data["points"],
			winners: +data["winners"],
			winnersList: data["winnerList"],
			death_date: data["death_date"],
			image_id: +data["image"],
			text: data["text"],
		};
	}

	private obituaryPipe = (rs: any) => {
		const list = rs.data.map((d: any) => this.getDeathFromData(d));
		return { list };
	};

	public getDeaths(): Observable<any> {
		return this.api.getDeaths()
			.pipe(map(this.obituaryPipe));
	}
	public getDeathsByYear(year: number): Observable<any> {
		return this.api.getDeathsByYear(year)
			.pipe(map(this.obituaryPipe));
	}
	public getDeath(id: string|number): Observable<iDeath> {
		return this.api.getDead(id)
			.pipe( map(rs => this.getDeathFromData(rs)) );
	}

}
